import React from 'react';
import { localeStore } from 'src/mobx/localesStore';
import { getTranslate } from 'src/utils/formatter';
import { branchStore } from 'src/mobx/barnchStore';
import { observer } from 'mobx-react';

const Location = observer(({ curbside }: { curbside: boolean }) => {
  return (
    <div>
      <p className="pickup-type">
        {localeStore.t(curbside ? 'consumer_confirm_curbside_popup_branchname_title' : 'txt_pickup_at')}
      </p>
      <p className="pickup-address">{getTranslate(branchStore.branch.name)}</p>
    </div>
  );
});

export default Location;
